/* unplugin-vue-components disabled */import { render } from "./account.vue?vue&type=template&id=5275243a"
import script from "./account.vue?vue&type=script&lang=js"
export * from "./account.vue?vue&type=script&lang=js"

import exportComponent from "/data/jenkins_home/workspace/JOINMC-H5-HTML-MASTER/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__